<template>
  <div id="app">
    <!-- <div class="header">
      <router-link to="/">
      <div class="logo-title">
        <div class="font-12">Designer</div>
        <div class="font-20 name">Daisuke Mori</div>
      </div>
      </router-link>
      <ul class="font-15">
        <li><router-link to="/">Top</router-link></li>
        <li><router-link to="/product">Works</router-link></li>
      </ul>
    </div> -->

    <router-view />
    <!-- <Form /> -->

    <!-- <div class="footer">
      <p id="page-top"><a href="#wrap"><img src="@/assets/img/pagetop.png"></a></p>
      Copyright© 2020 Dai Portfolio All rights reserved.
    </div> -->

    <!-- <div class="sns-icon">
      <a href="https://twitter.com/dai_designing" target="_blank"><img src="@/assets/img/tw_icon.png"></a>
      <a href="https://www.facebook.com/daisuke.mori.374" target="_blank"><img src="@/assets/img/fb_icon.png"></a>
      <a href="https://qiita.com/dai_designing" target="_blank"><img src="@/assets/img/qiita_icon.png"></a>
    </div> -->
  </div>
</template>

<script>
  // 認証関連
  import firebase from 'firebase'
  import Form from '@/components/Form.vue'

  document.ondragstart = () => { return false; };

  export default {
    name: 'App',
    components: { Form },
    mounted: function() {
      // fadein
      $(window).scroll(function (){
          $('.fadein').each(function(){
              let targetElement = $(this).offset().top;
              let scroll = $(window).scrollTop();
              let windowHeight = $(window).height();
              if (scroll > targetElement - windowHeight + 200){
                  $(this).css('opacity','1');
                  $(this).css('transform','translateY(0)');
              }
          });
      });
      // ページTOPに戻る
      let topBtn = $('#page-top');    
      topBtn.hide();
      //スクロールが100に達したらボタン表示
      $(window).scroll(function () {
          if ($(this).scrollTop() > 100) {
              topBtn.fadeIn();
          } else {
              topBtn.fadeOut();
          }
      });
      //スクロールしてトップ
      topBtn.click(function () {
          $('body,html').animate({
              scrollTop: 0
          }, 500);
          return false;
      });
    }
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Parisienne&display=swap');
  @import url('https://fonts.googleapis.com/css?family=PT+Serif:400i|Parisienne&display=swap');
  /* font-family: 'Parisienne', cursive; */
  /* font-family: 'PT Serif', serif; */
  * {
    font-family: 'PT Serif', serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .sp {
    display: none;
  }
  /* フォントサイズ定義 */
  .font-12 {
    font-size: 12px;
  }
  .font-13 {
    font-size: 13px;
  }
  .font-15 {
    font-size: 15px;
  }
  .font-18 {
    font-size: 18px;
  }
  .font-20 {
    font-size: 20px;
  }
  .font-23 {
    font-size: 23px;
  }
  .font-25 {
    font-size: 25px;
  }
  .font-30 {
    font-size: 30px;
  }
  .fadein {
    opacity : 0;
    transform: translateY(20px);
    transition: all 1s;
  }
  #page-top img {
    display: block;
    width: 50px;
    height: 50px;
    font-size: 15px;
    color: #fff;
    text-align: center;
    text-decoration: none;
    transition: .5s;
    right: 50px;
    bottom: 50px;
    position: fixed;
  }
  #page-top a:hover {
      opacity: .5;
  }
  h1, h2 {
    /* font-family: 'Parisienne', cursive; */
    font-weight: normal;
    margin: 0 0 15px 0;
  }
  ul li {
    list-style: none;
  }
  img {
    pointer-events: none;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 80%;
    height: 90px;
    margin: 0 auto;
    padding: 30px;
    background: #D6C6B4;
  }
  .header .logo-title {
    line-height: 1.25em;
  }
  .error {
    color: #ff7bb6;
  }
  .header ul li {
    display: inline-block;
    margin: 15px 0 0 10px;
  }
  .router-link-exact-active {
    color: #312312;
  }
  .container {
    text-align: center;
    width: 100%;
    margin: 75px auto 50px;
  }
  .footer {
    text-align: center;
    font-size: 10px;
    margin: 0 0 30px 0;
  }
  .sns-icon {
    left: 50px;
    bottom: 50px;
    position: fixed;
    z-index: 3;
  }
  .sns-icon img {
    display: block;
    width: 40px;
    height: 40px;
    margin: 0 0 5px 0;
    filter: drop-shadow(0 0 2px rgba(82, 30, 1, 0.3));
    transition: .5s;
  }
  .sns-icon img:hover {
    opacity: .3;
  }
  @media screen and (max-width:768px) {
    .pc {
      display: none;
    }
    .header .logo-title .name {
      font-size: 17px;
    }
    #page-top img {
      right: 20px;
      bottom: 20px;
    }
    .footer {
      text-align: center;
      font-size: 10px;
      width: 85%;
      margin: 0 auto 125px;
    }
    .sns-icon {
      left: 20px;
      bottom: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue